@if (order()) {
  <div class="mt-5 relative">
    <div class="card flex flex-wrap items-center justify-between gap-y-2">
      <div class="flex items-center gap-4">
        <p-button
          severity="secondary"
          routerLink="/orders"
          rounded
          class="btn-secondary-outline"
          icon="ph ph-arrow-left"
          title="Voltar para a lista de pedidos"
        ></p-button>
        <div>
          <div class="text-xl">
            <span class="font-bold"> Pedido </span>
            #{{ orderNumber() }}
          </div>
          <p>Siga as instruções para realizar a análise corretamente</p>
        </div>
      </div>

      <div
        class="flex flex-wrap items-center justify-end gap-x-6 gap-y-2 ml-auto"
      >
        <div class="flex items-center gap-2 whitespace-nowrap">
          <span class="text-gray-500"> Situação: </span>
          <app-tag-status
            [status]="statusTag()"
            [text]="statusText()"
          ></app-tag-status>
        </div>
        @if (canCancel()) {
          <div class="flex items-center gap-2 whitespace-nowrap">
            <p-button
              type="button"
              label="Cancelar"
              icon="ph ph-x-circle"
              severity="danger"
              [outlined]="true"
              rounded
              (click)="cancelDialogVisible.set(true)"
            ></p-button>
          </div>
        }
      </div>
    </div>
  </div>

  @if (isOrderCancelled()) {
    <app-order-cancellation-card [order]="order()" />
  }

  <p-tabs value="1" class="mt-5">
    <p-tablist>
      <p-tab value="1">Detalhes do Pedido</p-tab>
      <p-tab value="2">Sobre o Cliente</p-tab>
      <p-tab value="3">Taxa de Inscrição</p-tab>
      <p-tab value="4">Parcelas</p-tab>
      <p-tab value="5">Análise</p-tab>
      <p-tab value="6">Histórico</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="1">
        <div class="flex flex-wrap lg:flex-nowrap gap-3">
          <div class="w-full lg:w-1/2">
            <div class="card">
              <p class="font-bold">Produto</p>

              <div class="flex flex-wrap w-full gap-3 mt-5">
                <div class="bg-gray-100 h-30 text-center relative rounded-lg">
                  <img
                    [src]="product?.mainImageUrl ?? ''"
                    class="w-30 h-30 object-cover rounded-lg"
                  />
                </div>
                <div class="w-full">
                  <p class="font-bold text-2xl">
                    {{
                      product!.modelVersionName ||
                        product!.modelName ||
                        product!.name ||
                        "-"
                    }}
                  </p>
                  <div class="flex gap-3">
                    <div class="w-full">
                      <div class="mt-5">
                        <p>Cor</p>
                        <p class="font-bold mt-2">
                          {{ productColor() }}
                        </p>
                      </div>
                      <div class="mt-5">
                        <p>Capacidade</p>
                        <p class="font-bold mt-2">
                          {{ productCapacity() }}
                        </p>
                      </div>
                      <div class="mt-5">
                        <p>SKU</p>
                        <p class="font-bold mt-2">
                          {{ product!.sku }}
                        </p>
                      </div>
                    </div>
                    @if (order()!.productIdentifiers.length) {
                      <div
                        class="inline-block h-55 w-px self-stretch bg-gray-400"
                      ></div>
                      <div class="w-full pr-5">
                        <div class="flex flex-wrap gap-3">
                          @for (
                            identifier of order()!.productIdentifiers;
                            track identifier.id
                          ) {
                            <div class="mt-5">
                              <p>{{ identifier.productIdentifierTypeName }}</p>
                              <p class="font-bold mt-2">
                                {{ identifier.value }}
                              </p>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>

            <div class="flex flex-wrap lg:flex-nowrap gap-3 mt-3">
              @if (order()?.contract) {
                <div class="card w-full lg:w-1/2">
                  <p class="font-bold">Contrato</p>
                  <div class="w-fit mt-5">
                    <app-tag-status
                      [status]="contractTag().status"
                      [text]="contractTag().text"
                    ></app-tag-status>
                    @if (contractSigned()) {
                      <p class="mt-2">
                        Assinado em:
                        {{
                          order()?.contract!.signedAt | date: "dd/MM/yyyy HH:mm"
                        }}
                      </p>
                    }
                  </div>
                  <div class="mt-5">
                    <a
                      class="mt-5 text-blue-800 underline! cursor-pointer"
                      (click)="openContractDialog()"
                      >Ver contrato</a
                    >
                  </div>
                </div>
              }
              @if (currentCard()) {
                <div class="card w-full lg:w-1/2">
                  <p class="font-bold">Meio de Pagamento</p>

                  <div class="mt-5">
                    <p class="font-bold">
                      {{ currentCard()!.brand | titlecase }} ••••
                      {{ currentCard()!.displayNumber }}
                    </p>
                    <p class="mt-2">
                      Expira em
                      {{ formatCardExpirationDate(currentCard()!) }}
                    </p>
                  </div>
                </div>
              }
            </div>
          </div>

          @if (shipment() != null) {
            <div class="card w-full lg:w-1/2">
              <div class="flex gap-5 items-center">
                <div class="font-bold">Envio</div>
                @if (orderDelivered()) {
                  <div class="w-fit">
                    <app-tag-status
                      text="Pedido Entregue"
                      status="Delivered"
                    ></app-tag-status>
                  </div>
                }
              </div>

              @if (orderDelivered()) {
                <div class="mt-5">
                  <p class="font-bold">Endereço</p>
                  <div class="mt-1">
                    {{ order()?.shippingAddress?.street || "-" }} -
                    {{ order()?.shippingAddress?.city || "-" }},
                    {{ order()?.shippingAddress?.state || "-" }}
                    {{ order()?.shippingAddress?.zipCode || "-" }}
                  </div>
                </div>
              }

              <div class="flex flex-wrap justify-between gap-6 mt-5">
                <div>
                  <div class="text-sm font-bold">Transportadora</div>
                  <div class="mt-1">
                    {{ shipment()!.carrierName || "-" }}
                  </div>
                </div>

                <div>
                  <div class="text-sm font-bold">Código de Rastreio</div>
                  <div class="mt-1">
                    @if (shipment()!.trackingCode) {
                      {{ shipment()!.trackingCode }}
                    } @else {
                      -
                    }
                  </div>
                </div>

                <div>
                  <div class="text-sm font-bold">Data de Envio</div>
                  <div class="mt-1">
                    @if (shipment()!.shippedAt) {
                      {{ shipment()!.shippedAt | date: "dd/MM/yyyy" }}
                    } @else {
                      -
                    }
                  </div>
                </div>

                <div>
                  <div class="text-sm font-bold">Previsão Entrega</div>
                  <div class="mt-1">
                    @if (shipment()!.estimatedDeliveryDate) {
                      {{
                        shipment()!.estimatedDeliveryDate | date: "dd/MM/yyyy"
                      }}
                    } @else {
                      -
                    }
                  </div>
                </div>

                <div>
                  <div class="text-sm font-bold">Anotações</div>
                  <div class="mt-1">
                    @if (shipment()?.note) {
                      {{ shipment()!.note ?? "-" }}
                    } @else {
                      -
                    }
                  </div>
                </div>
              </div>

              @if (!orderDelivered()) {
                <div class="mt-5">
                  <div class="w-1/2">
                    <div class="text-sm font-bold">Status do Transporte</div>
                    <p-select
                      [options]="shipmentStatusOptions"
                      optionLabel="label"
                      optionValue="value"
                      [(ngModel)]="shipmentStatus"
                      placeholder="Selecione o status do pedido"
                      class="w-full"
                    ></p-select>
                  </div>

                  <p-button
                    type="button"
                    label="Salvar"
                    rounded
                    (click)="updateShipmentStatus()"
                    class="block mt-5 w-fit"
                  ></p-button>
                </div>
              }
            </div>
          }
        </div>
      </p-tabpanel>

      <p-tabpanel value="2">
        <div class="card">
          <div class="text-lg font-bold mb-3">Dados pessoais</div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <div class="text-sm font-bold">Nome Completo</div>
              <div class="mt-1">
                {{ customer.fullName || "-" }}
              </div>
            </div>

            <div>
              <div class="text-sm font-bold">Data de Nascimento</div>
              <div class="mt-1">
                {{ customer.dateOfBirth | date: "dd/MM/yyyy" }}
              </div>
            </div>
          </div>

          <hr class="my-6" />

          <div class="text-lg font-bold mb-3">Contato</div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <div class="text-sm font-bold">Telefone</div>
              <div class="mt-1">{{ primaryPhone }}</div>
            </div>

            <div>
              <div class="text-sm font-bold">E-mail</div>
              <div class="mt-1">{{ primaryEmail }}</div>
            </div>
          </div>

          <hr class="my-6" />

          <div class="text-lg font-bold mb-3">Endereço de entrega</div>

          <div class="flex flex-wrap gap-6">
            <div class="md:col-span-2">
              <div class="text-sm font-bold">Street Address</div>
              <div class="mt-1">
                {{ order()?.shippingAddress?.street || "-" }}
              </div>
            </div>

            <div>
              <div class="text-sm font-bold">Apt, Suite, Unit (Optional)</div>
              <div class="mt-1">
                {{ order()?.shippingAddress?.complement || "-" }}
              </div>
            </div>

            <div>
              <div class="text-sm font-bold">City</div>
              <div class="mt-1">
                {{ order()?.shippingAddress?.city || "-" }}
              </div>
            </div>

            <div>
              <div class="text-sm font-bold">State</div>
              <div class="mt-1">
                {{ order()?.shippingAddress?.state || "-" }}
              </div>
            </div>

            <div>
              <div class="text-sm font-bold">ZIP Code</div>
              <div class="mt-1">
                {{ order()?.shippingAddress?.zipCode || "-" }}
              </div>
            </div>
          </div>

          <a
            pButton
            class="btn-secondary-outline mt-5"
            severity="secondary"
            rounded
            [routerLink]="'/customers/details/' + customer.id"
          >
            Ver dados do cliente
          </a>
        </div>
      </p-tabpanel>

      <p-tabpanel value="3">
        <app-order-down-payment [order]="order()" />
      </p-tabpanel>

      <p-tabpanel value="4">
        <app-order-installments
          [order]="order()"
          [product]="product"
          (reloadOrder)="reloadOrder.emit()"
          (setLoading)="setLoading.emit($event)"
        />
      </p-tabpanel>

      <p-tabpanel value="5">
        <div class="flex flex-wrap lg:flex-nowrap gap-3">
          <div class="card w-full lg:w-1/2">
            <div class="text-xl font-bold mb-6">Documentos</div>

            @if (documents.length) {
              <div class="space-y-6">
                @for (doc of documents; track $index) {
                  <div class="flex items-center justify-between gap-4">
                    <div class="flex items-center gap-4">
                      <i
                        class="ph ph-file-text text-purple-primary-500 text-4xl"
                      ></i>

                      <div>
                        <div class="font-bold">
                          {{ getDocumentNameByType(doc.type) }}
                        </div>
                        <div class="text-sm">
                          Enviado em
                          {{ doc.uploadedAt | date: "dd/MM/yyy HH:mm" }}
                        </div>
                      </div>
                    </div>

                    <div class="flex gap-2">
                      <a
                        pButton
                        rounded
                        severity="secondary"
                        class="btn-secondary-outline"
                        [href]="doc.fileUrl"
                        target="_blank"
                      >
                        Baixar
                      </a>
                    </div>
                  </div>

                  @if ($index < documents.length - 1) {
                    <hr />
                  }
                }
              </div>
            } @else {
              <div class="">Nenhum documento enviado.</div>
            }
          </div>
          @if (eligibilityAssessment()) {
            <div class="card w-full lg:w-1/2">
              <app-order-assessment
                [orderId]="order()?.id"
                [orderStatus]="order()?.status"
                [eligibilityAssessment]="eligibilityAssessment()"
                [customerName]="customer.fullName"
                [approvalPrerequisites]="order()?.approvalPrerequisites ?? null"
              />
            </div>
          }
        </div>
      </p-tabpanel>

      <p-tabpanel value="6">
        <div class="flex flex-wrap lg:flex-nowrap gap-3">
          <div class="card w-full lg:w-1/2">
            <h4 class="text-h4 font-bold">Histórico</h4>

            @if (order()?.histories?.length) {
              <div class="mt-5 space-y-2">
                @for (historic of order()!.histories; track historic.id) {
                  <div>
                    <div class="font-bold">
                      <p>
                        {{ getOrderStatusDescription(historic.to!) }}
                      </p>
                    </div>
                    <p>
                      {{
                        historic.transitionedAt
                          | date: "dd / MMM / yyyy 'às' HH:mm"
                      }}
                    </p>
                  </div>
                }
              </div>
            } @else {
              <p class="mt-5">Nenhum histórico gerado</p>
            }
          </div>

          <div class="card w-full lg:w-1/2">
            <h4 class="text-h4 font-bold">Envio</h4>

            @if (shipment()?.histories?.length) {
              <div class="mt-5 space-y-2">
                @for (historic of shipment()!.histories; track historic.id) {
                  <div>
                    <div class="font-bold">
                      <p>
                        {{ getShipmentStatusDescription(historic.to!) }}
                      </p>
                    </div>
                    <p>
                      {{
                        historic.transitionedAt
                          | date: "dd / MMM / yyyy 'às' HH:mm"
                      }}
                    </p>
                  </div>
                }
              </div>
            } @else {
              <p class="mt-5">Nenhum histórico de envio gerado</p>
            }
          </div>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <p-dialog
    [(visible)]="contractDialogVisible"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [style]="{ width: '55rem' }"
    header="Contrato"
  >
    @if (getContractUrl()) {
      <iframe
        title="Contract"
        [src]="getContractUrl()"
        class="w-full h-120"
      ></iframe>
    }
  </p-dialog>
}
<app-order-cancel-dialog
  [(visible)]="cancelDialogVisible"
  [order]="order()"
  (cancelled)="reloadOrder.emit()"
/>

<p-confirmDialog [style]="{ width: '500px', maxWidth: '90vw' }">
  <!-- <ng-template
    pTemplate="footer"
    let-onAccept="onAccept"
    let-onReject="onReject"
  >
    <div class="flex justify-end gap-3">
      <p-button
        label="Cancelar"
        severity="secondary"
        rounded
        class="btn-secondary-outline"
        (onClick)="onReject()"
      >
      </p-button>
      <p-button
        rounded
        type="button"
        label="Confirmar"
        class="btn-primary"
        (onClick)="onAccept()"
      ></p-button>
    </div>
  </ng-template> -->
</p-confirmDialog>
